<template>
  <div class="bg-top bg-no-repeat bg-contain h-full mx-auto relative">
    <img src="@/assets/images/about/intro.png" />
    <div class="my-video">
      <video
        id="myVideo"
        webkit-playsinline="true"
        playsinline="true"
        class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid"
      >
        <source :src="`${publicPath}videos/about.mp4`" type="video/mp4" />
      </video>
    </div>
    <img src="@/assets/images/about/intro1.png" />
  </div>
</template>
<script>
import Video from "video.js";
import "video.js/dist/video-js.css";
import video_zhCN from "video.js/dist/lang/zh-CN.json";
Video.addLanguage("zh-CN", video_zhCN);

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    setTimeout(() => {
      this.player = Video("myVideo", {
        controls: true,
        autoplay: false,
        poster: `${this.publicPath}videos/about.jpg`,
        // preload: "auto",
        // height: 180,
        fluid: true,
        language: "zh-CN", // 设置语言
        width: "auto",
      });
      if (this.isWifi()) {
        this.player.play();
      } else {
        this.player.pause();
      }
    }, 300);
  },
  methods: {
    isWifi() {
      try {
        let wifi = true;
        let ua = window.navigator.userAgent;
        let con = window.navigator.connection;
        // 如果是微信
        if (/MicroMessenger/.test(ua)) {
          if (ua.indexOf("WIFI") >= 0) {
            return true;
          } else {
            wifi = false;
          }
          // 如果支持navigator.connection
        } else if (con) {
          let network = con.type;
          if (network !== "wifi" && network !== "2" && network !== "unknown") {
            wifi = false;
          }
        }
        return wifi;
      } catch (e) {
        return false;
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="less" scoped>
.my-video {
  padding: 10px 50px;
  background-color: rgb(215, 224, 228);
  border-color: rgb(215, 224, 228);
}

/deep/.vjs-poster {
  background-color: unset;
}
</style>
